import React from 'react';
import useGetDocument from '@data/document/hooks/useGetDocument/useGetDocument';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { useGetSignedUrlAndGetDoc } from '@data/document/hooks/useGetSignedUrlAndGetDoc/useGetSignedUrlAndGetDoc';

const useGetDocumentObjectUrl = (documentId: string | undefined) => {
	const getDoc = useGetDocument();
	const getSignedUrlAndGetDoc = useGetSignedUrlAndGetDoc();
	const { ssmuiSignedUrl } = useSsmUiFlags();
	const [docUrl, setDocUrl] = React.useState<string | undefined>(undefined);

	React.useEffect(() => {
		if (!documentId) { return; }

		const onSuccess = (doc: Blob) => {
			setDocUrl(window.URL.createObjectURL(doc));
		};

		if (ssmuiSignedUrl) {
			getSignedUrlAndGetDoc(documentId, onSuccess);
		} else {
			getDoc(documentId, onSuccess);
		}
	}, [documentId, getDoc, getSignedUrlAndGetDoc, ssmuiSignedUrl]);

	React.useEffect(() => {
		const prevUrl = docUrl;
		return () => {
			if (!prevUrl) { return; }
			window.URL.revokeObjectURL(prevUrl);
		};
	}, [docUrl]);
	return docUrl;
};

export default useGetDocumentObjectUrl;
